import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicLayout, { H1, Lead } from "../../components/PublicLayout";
import { Developments } from "../../components/landing/home2/FeaturedModules";
import { SITE } from "../../content/site";
import { routePath } from "../../lib/routes";
import { track, EVENTS } from "../../lib/analytics";

export default function Work({ lang }) {
  const c = (SITE[lang].work2 || SITE.en.work2);
  const nav = SITE[lang].nav.work ? SITE[lang].nav : SITE.en.nav;
  useEffect(() => { window.scrollTo(0, 0); track(EVENTS.PAGE_VIEW, { page: "work", lang }); }, [lang]);

  return (
    <PublicLayout pageKey="work" lang={lang}
      crumbs={[{ name: nav.work, path: routePath("work", lang) }]}>
      <div data-testid="work-page">
        <section className="mx-auto max-w-[1200px] px-6 pb-16 pt-14 md:px-8 md:pb-20 md:pt-20">
          <p className="overline mb-4 text-[#9a9a9a]">{c.overline}</p>
          <H1>{c.h1}</H1>
          <Lead>{c.sub}</Lead>
        </section>
        <Developments standalone />
        <section className="mx-auto max-w-[1200px] px-6 pb-24 md:px-8 md:pb-32">
          <Link to={routePath("products", lang)} data-testid="work-products-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#0e7c6b] transition-opacity hover:opacity-75">
            {c.allCta} <ArrowRight size={16} />
          </Link>
        </section>
      </div>
    </PublicLayout>
  );
}
